import { render, staticRenderFns } from "./EventHeader.vue?vue&type=template&id=c02b25e8&"
import script from "./EventHeader.vue?vue&type=script&lang=js&"
export * from "./EventHeader.vue?vue&type=script&lang=js&"
import style0 from "./EventHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCardTitle,VImg})
